<template>
  <div class="container">
    <div class="row">
      <app-footer-city-logo
        class="col-md-3 col-sm-12 text-center"
        :class="{'offset-md-3': !hasContactFilled, 'offset-md-1': hasContactFilled}"
        :cityName="configuration.cityName"
        :cityWebsite="configuration.cityWebsite"
        :logo="configuration.logo"
      />
      <app-footer-city-information
        class="col-md offset-md-1 offset-4 col-6 mt-3 text-left"
        :configuration="configuration"
      />
      <app-footer-city-contact
        class="offset-md-1 col-md offset-4 col-6 mt-3 text-left"
        v-if="hasContactFilled"
        :configuration="configuration"
      />
    </div>
  </div>
</template>

<script>
import appFooterCityInformation from './app-footer-city-information'
import appFooterCityLogo from './app-footer-city-logo'
import appFooterCityContact from './app-footer-city-contact'

export default {
  name: 'app-footer-city',
  components: {
    appFooterCityInformation,
    appFooterCityLogo,
    appFooterCityContact
  },
  props: {
    configuration: Object
  },
  computed: {
    hasContactFilled () {
      return !!(
        this.configuration.tlpeContactName ||
        this.configuration.tlpeContactPhone ||
        this.configuration.tlpeContactAddress ||
        this.configuration.tlpeContactMail
      )
    }
  }
}
</script>

<style scoped>
  .container {
    padding: 1rem 0;
    font-size: 0.8rem;
  }

  .row {
    align-items: center;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/app-footer-city.vue